import React, { useState } from 'react';
import axios from 'axios';
import { useAuth0 } from '@auth0/auth0-react';

function EditModModal({ mod, onClose, onUpdate }) {
  const { getAccessTokenSilently } = useAuth0();
  const [formData, setFormData] = useState({ ...mod });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSave = async () => {
    const token = await getAccessTokenSilently();
    await axios.put(`${process.env.REACT_APP_API_BASE_URL}/api/mods/${mod.id}`, formData, {
      headers: { Authorization: `Bearer ${token}` },
    });
    onUpdate();
    onClose();
  };

  return (
    <div className="modal">
      <h3>Edit Mod</h3>
      <label>
        Game:
        <input name="game" value={formData.game} onChange={handleChange} />
      </label>
      <br/>
      <label>
        Mod Name:
        <input name="modName" value={formData.modName} onChange={handleChange} />
      </label>
      <br/>
      <label>
        Mod Version:
        <input name="modVersion" value={formData.modVersion} onChange={handleChange} />
      </label>
      <br/>
      <label>
        Game Version:
        <input name="gameVersion" value={formData.gameVersion} onChange={handleChange} />
      </label>
      <br/>
      <label>
        Squad File Link:
        <input name="squadFileLink" value={formData.squadFileLink} onChange={handleChange} />
      </label>
      <br/>
      <label>
        Mod Link:
        <input name="modLink" value={formData.modLink} onChange={handleChange} />
      </label>
      <br/>

      <button onClick={handleSave}>Save</button>
      <br/>
      <button onClick={onClose}>Cancel</button>
    </div>
  );
}

export default EditModModal;
